import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessibilityComponent } from './pages/accessibility/accessibility.component';

import { AppAuthGuard } from './app-auth.guard';
import { PermissionActions } from './app.permission.actions';
import { SupportComponent } from './pages/support/support.component';
import { AboutComponent } from './pages/about/about.component';
import { FeedbackComponent } from './pages/feedback/feedback.component';

export const routes: Routes = [
    { path: '', redirectTo: 'screen/search', pathMatch: 'full' },
    { path: 'index.jsp', redirectTo: 'screen/search' },
    { path: 'screen/logged/home', redirectTo: 'screen/logged/search' },
    { path: 'screen/home', redirectTo: 'screen/search' },
    {
        path: 'screen/accessibility',
        data: { label: 'toolbar.accessibility' },
        component: AccessibilityComponent,
    },
    {
        path: 'screen/support',
        data: { label: 'toolbar.support' },
        component: SupportComponent,
    },
    {
        path: 'screen/feedback',
        data: { label: 'toolbar.feedback' },
        component: FeedbackComponent,
    },
    {
        path: 'screen/about',
        data: { label: 'toolbar.about' },
        component: AboutComponent,
    },
    {
        path: 'screen/logged/search',
        data: { label: 'toolbar.search' },
        loadChildren: () => import('./features/search/search.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/search',
        data: { label: 'toolbar.search' },
        loadChildren: () => import('./features/search/search.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/list',
        data: { label: 'list.notification' },
        loadChildren: () => import('./features/list/list.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/list',
        data: { label: 'list.notification' },
        loadChildren: () => import('./features/list/list.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/notification',
        data: { label: 'list.notification' },
        loadChildren: () =>
            import('./features/notification/notification.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/notification/:id',
        data: { label: 'list.notification' },
        loadChildren: () =>
            import('./features/notification/notification.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/notification',
        data: { label: 'list.notification' },
        loadChildren: () =>
            import('./features/notification/notification.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/notification/:id',
        data: { label: 'list.notification' },
        loadChildren: () =>
            import('./features/notification/notification.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/consumers',
        data: { label: 'toolbar.consumers' },
        loadChildren: () => import('./features/consumers/consumers.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/consumers',
        data: { label: 'toolbar.consumers' },
        loadChildren: () => import('./features/consumers/consumers.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/catalogues',
        redirectTo: 'screen/logged/catalogues/list',
    },
    {
        path: 'screen/logged/catalogues/list',
        data: {
            permission: PermissionActions.OpenCatalogueManagementConsole,
            label: 'toolbar.catalogues',
        },
        loadChildren: () =>
            import('./features/catalogues/ct-list/ct-list.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/laboratories',
        data: {
            label: 'actor.laboratories.management',
            permission: PermissionActions.SearchLaboratoryItem,
        },
        loadChildren: () =>
            import('./features/laboratories/laboratories.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/operators',
        data: {
            label: 'actor.operators.management',
            permission: PermissionActions.SearchOperatorItem,
        },
        loadChildren: () => import('./features/operators/operators.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/notices',
        data: {
            label: 'toolbar.notices',
            permission: PermissionActions.CreateAlertBanner,
        },
        loadChildren: () => import('./features/notices/notices.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    {
        path: 'screen/logged/consumer-link',
        data: {
            label: 'toolbar.consumerLink',
            permission: PermissionActions.CreateAlertBanner,
        },
        loadChildren: () =>
            import('./features/consumer-link/consumer-link.module').then((m) => m.Module),
        canActivate: [AppAuthGuard],
    },
    // LEGACY Routes
    { path: 'consumers', redirectTo: 'screen/consumers' },
    { path: 'portal', redirectTo: 'screen/search' },
    // 404
    { path: '**', redirectTo: 'screen/search' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            anchorScrolling: 'enabled',
        }),
    ],
})
export class AppRoutingModule {}
